import React, { memo } from 'react'
import { Spinner, Image } from 'react-bootstrap';
import { useParams } from 'react-router'
import LazyImage from '../../../../Components/LazyImage';
import { useFetchData } from '../../../../Hooks/Main/useFetchData';
import HtmlDecode from '../../../../Utils/HtmlDecode';
const imgPath = process.env.REACT_APP_FILE_URL

function SliderDetails() {

    const { id } = useParams()
    const lang = localStorage.getItem("i18nextLng")
    const { data, isLoading } = useFetchData(`getSliderDetails/${id}`, lang);
    console.log("data", data)

    return !isLoading ? (
      
    <div className="container-fluid  p-0">
        <div className="position-relative d-flex justify-content-center pagesHeaderCoverImages">
            <LazyImage
            src={`${imgPath}${data?.images?.file}`}
            fluid
            alt="child labour image mt-5"
            bsPrefix="img"/> 
              {/* <div className='p-0 m-0' style={{
                  backgroundImage: "url(../../../images/slider/childLabour.webp)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  width:"100%"
              }}>
                
              </div> */}
        <div className="image-frame__wrapper">
          <h2>{data?.subModule?.name}</h2>
        </div>
      </div>
        <div className="container">
              <div className="row mt-4">
                  <div className='col-md-9 mb-3'>
                      {data?.localContent?.map((content, index) => {
                          return (
                            <div className='container-fluid my-3' key={index}>
                                {index!==0 && <h6>{content.title}</h6>}
                                  <p>
                                      <span
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                    __html: HtmlDecode(content?.content),
                                    }}
                                      />
                                  </p>
                            </div>
                        )
                    })}
                  </div>
                  {/* <div className='col-md-3 mb-3'>
                    <Image src={require("../../../../Assets/Images/aboutbg.png")} alt="contentImages" fluid/>
                  </div> */}
              </div>
          </div>
      </div>
      
  ):<div className="d-flex justify-content-center mt-3">
      <Spinner animation="grow" className="me-2" />
      Loading Content...
    </div>
}

export default memo(SliderDetails)